import { SupplierDirectDeliveryMessageUI } from "./SupplierDirectDeliveryMessageUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { getSupplierDirectOption } from "../../utils/product/isSupplierDirect";
import { isEligibleForFreeReturns } from "@/utils/product/isEligibleForFreeReturns";
import { DMS_IDS } from "@/constants/constants";
export function SupplierDirectDeliveryMessage({
  product,
}: Pick<StandardProps, "product">) {
  const {
    variant: { availability },
  } = useVariant(product);

  const isAvailableToOrder = availability?.availableToOrder ?? false;

  const comingSoon = availability?.futureAvailability ?? false;

  const supplierDeliveryOption = getSupplierDirectOption(product);

  const shouldDisplay =
    supplierDeliveryOption !== null &&
    (isAvailableToOrder || comingSoon) &&
    (supplierDeliveryOption.aliases.dmsId === DMS_IDS.SupplierDelivery
      ? !isEligibleForFreeReturns(product)
      : true);

  return shouldDisplay ? (
    <SupplierDirectDeliveryMessageUI
      deliveryCost={supplierDeliveryOption?.price?.value}
    />
  ) : null;
}
